module.exports = __webpack_public_path__ + "media/images/flags/US-36970c8b0bf7997a548fe0035c2cf420.svg";